export const resetAfterSuccessfulSend = ({
  getCandidates,
  resetChanges,
  resetList,
  setEditorHtml,
  setReferenceEditorHtml,
  setSelectedCandidateIds,
  setSelectedTemplate,
  setSelectedTemplateId,
  setSubject,
}) => {
  resetList();
  getCandidates();
  setSelectedCandidateIds([]);
  setSelectedTemplate(null);
  setSelectedTemplateId('placeholder');
  setSubject('');
  setEditorHtml('<p></p>');
  setReferenceEditorHtml('<p></p>');
  resetChanges();
};
